import React, { useEffect, useState } from "react";
import { MainLayoutAdmin } from "../../../layout/MainLayoutAdmin";
import { useNavigate } from "react-router-dom";
import { HOST } from "../../../config";

function SimulationCreate() {
  const [name, setName] = useState();
  const [image, setImage] = useState();
  const [video, setVideo] = useState();
  const [point, setPoint] = useState();
  const [disableBtn, setDisableBtn] = useState(false);
  const navigate = useNavigate();

  function handleSave() {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      navigate("/admin/login");
    }

    if (!name) {
      alert("Chưa nhập trên bài kiểm tra");
      return;
    }

    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      name,
      image,
      video,
      point,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    setDisableBtn(true)
    fetch(`${HOST}/simulation/`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        setDisableBtn(false)
        navigate("/admin/simulation/");
      })
      .catch((error) => console.log("error", error));
  }
  return (
    <MainLayoutAdmin>
      <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className="align-middle inline-block min-w-full">
            <div className="shadow overflow-hidden p-2">
              <div className="mb-6">
                <label className="block mb-2 font-medium text-gray-900">
                  Câu hỏi số
                </label>
                <input
                  onChange={(e) => setName(e.target.value)}
                  type="number"
                  className="border text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
              </div>

              <div className="mb-6">
                <label className="block mb-2 font-medium text-gray-900">
                  Ảnh gợi ý
                </label>
                <input
                  onChange={(e) => setImage(e.target.value)}
                  className="border text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
              </div>

              <div className="mb-6">
                <label className="block mb-2 font-medium text-gray-900">
                  Video
                </label>
                <input
                  onChange={(e) => setVideo(e.target.value)}
                  className="border text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
              </div>

              <div className="mb-6">
                <label className="block mb-2 font-medium text-gray-900">
                  Điểm: Định dạng: Thời gian:Điểm . Ví dụ 10:10 : giây 10 đc 10 điểm
                </label>
                <input
                  onChange={(e) => setPoint(e.target.value)}
                  className="border text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
              </div>
              {!disableBtn ? (
                <button
                  onClick={handleSave}
                  type="submit"
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                >
                  Tạo câu hỏi
                </button>
              ) : (
                <button
                  type="submit"
                  disabled={disableBtn}
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                >
                  Đang tạo câu hỏi
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </MainLayoutAdmin>
  );
}

export default SimulationCreate;
